import React, { useEffect, useState } from "react";
import { Container, Modal, Form, Button } from "react-bootstrap";
import { FaBook, FaChalkboardTeacher, FaClipboardList, FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  getSectionsByLanguage,
  getExamCatesByLanguage,
} from "../../services/apiService";
import { useNavigate } from "react-router-dom";
import i18next from "i18next";
import { useAuth } from "../../contexts/AuthContext";
import info from "../../theme/assets/yasal_bilgilendirme_metni.png";
import Footer from "../Footer/Footer";
import "./Dashboard.css";

function Dashboard() {
  const { user } = useAuth();
  const { t } = useTranslation(["dashboard"]);
  const [exams, setExams] = useState([]);
  const [sections, setSections] = useState([]);
  const [hoveredCardIndex, setHoveredCardIndex] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [isRead, setIsRead] = useState(true);
  const navigate = useNavigate();

  const isRtlFont =
    i18next.language === "ar" ||
    i18next.language === "fa" ||
    i18next.language === "ru";

  useEffect(() => {
    document.title = t("headers:main-page");
    const stored = localStorage.getItem("isRead");
    setIsRead(stored === "false" ? false : true);
  }, [t]);

  useEffect(() => {
    fetchLatestExams();
    fetchBooks();
  }, [i18next.language]);

  const fetchLatestExams = async () => {
    const data = await getExamCatesByLanguage(i18next.language, user.moduleId);
    setExams(data);
  };

  const fetchBooks = async () => {
    const data = await getSectionsByLanguage(i18next.language, user.moduleId);
    setSections(data);
  };

  const handleCheckboxChange = () => setIsChecked(!isChecked);

  const handleClose = () => {
    setIsRead(false);
    localStorage.setItem("isRead", !isChecked);
  };

  return (
    <div className="dashboard-modern" style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <div style={{ flex: 1 }}>
        <Container fluid className="px-3 px-md-4 pt-4">
          <section className="dashboard-actions">
            <Link to="/examcates" className="dashboard-action-card snavlar">
              <div className="icon-wrap">
                <FaClipboardList />
              </div>
              <h3>{t("dashboard:exams")}</h3>
              <p>{t("dashboard:exams-desc")}</p>
              <span className="btn-link">
                {t("dashboard:details")} <FaArrowRight />
              </span>
            </Link>
            <Link to="/books" className="dashboard-action-card kitaplar">
              <div className="icon-wrap">
                <FaBook />
              </div>
              <h3>{t("dashboard:books")}</h3>
              <p>{t("dashboard:books-desc")}</p>
              <span className="btn-link">
                {t("dashboard:details")} <FaArrowRight />
              </span>
            </Link>
          </section>

          <section className="dashboard-sections">
            <div className="dashboard-section-card">
              <div className="dashboard-section-header">
                <div className="icon-wrap">
                  <FaChalkboardTeacher />
                </div>
                <h2>{t("dashboard:exams")}</h2>
              </div>
              <div className="dashboard-exam-grid">
                {exams.map((exam) => (
                  <Link
                    key={exam.id}
                    to={`/exam/${exam.id}`}
                    className="dashboard-exam-card"
                  >
                    <div className="dashboard-exam-card-icon">
                      <FaClipboardList />
                    </div>
                    <span className="dashboard-exam-card-name">{exam.name}</span>
                  </Link>
                ))}
              </div>
            </div>

            <div className="dashboard-section-card">
              <div className="dashboard-section-header dashboard-books-header">
                <div className="icon-wrap">
                  <FaBook />
                </div>
                <h2>{t("dashboard:lessons")}</h2>
              </div>
              <div className="dashboard-books-grid">
                {sections.map((book, index) => (
                  <div
                    key={book.id}
                    className="dashboard-book-card"
                    onMouseEnter={() => setHoveredCardIndex(index)}
                    onMouseLeave={() => setHoveredCardIndex(null)}
                    onClick={() => navigate(`/bookparts/${book.id}`)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        navigate(`/bookparts/${book.id}`);
                      }
                    }}
                  >
                    <img src={book.image} alt={book.name} />
                    <span
                      className="book-name"
                      style={{
                        fontFamily: isRtlFont ? "inherit" : "Anton, sans-serif",
                      }}
                    >
                      {book.name}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </Container>
      </div>

      <Modal size="xl" show={isRead} className="dashboard-modal" centered>
        <Modal.Header>
          <Modal.Title>{t("dashboard:info-message")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img
            src={info}
            alt="info"
            style={{
              width: "100%",
              maxWidth: 800,
              height: "auto",
              display: "block",
              margin: "0 auto",
              borderRadius: 8,
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Form.Check
            type="checkbox"
            label="Okudum, anladım ve kabul ediyorum."
            checked={isChecked}
            onChange={handleCheckboxChange}
          />
          <Button
            variant="primary"
            disabled={!isChecked}
            onClick={handleClose}
          >
            Onayla
          </Button>
        </Modal.Footer>
      </Modal>

      <Footer />
    </div>
  );
}

export default Dashboard;
